import Vue from 'vue';

interface UzCryptoServiceResponse {
  cbid?: number;
  result?: any;
  success?: boolean;
  token?: string;
}

interface UzCryptoServiceSubject {
  '1.2.860.3.16.1.1'?: string;
  '1.2.860.3.16.1.2'?: string;
  C?: string;
  CN?: string;
  L?: string;
  O?: string;
  SN?: string;
  ST?: string;
  UID?: string;
  businessCategory?: string;
  name?: string;
  title?: string;
}

const WS_CONNECTION =
  window.location.protocol === 'https:' && !window.navigator.platform.toLowerCase().includes('mac')
    ? 'wss://127.0.0.1:64201'
    : 'ws://127.0.0.1:64200';

const subjectParse = (subject: string): UzCryptoServiceSubject => {
  const parse = subject.split(',');
  const myObject: UzCryptoServiceSubject = {};
  parse.forEach((m: string) => {
    const split = m.split('=');
    myObject[split[0]] = split[1];
  });
  return myObject;
};

export default class UzCryptoService {
  public activeKey: { token: string; serial: string; url: string; pinpp: string } | null = null;
  public response: UzCryptoServiceResponse | null = null;
  public version: UzCryptoServiceResponse | null = null;
  public tokenList: UzCryptoServiceResponse | null = null;
  public allKeyList: UzCryptoServiceResponse | null = null;
  public connected: boolean = false;
  public reConnectionCount: number = 0;
  public socket: WebSocket | null = null;
  public isProduction: boolean = process.env.NODE_ENV === 'production';

  constructor() {
    console.log(1111111);
    this.connection();
  }

  public connection(): void {
    // if (window.navigator.platform.toLowerCase().includes('blink')) {
    this.socket = new WebSocket(WS_CONNECTION);
    this.subscription();
    // }
  }

  public subscription(): void {
    console.log('sdfsdf');
    if (!this.socket) return;

    this.socket.onopen = (): void => {
      this.connected = true;
      this.reConnectionCount = 0;
      this.socket!.onmessage = (event): void => {
        console.log('asdfasfasdf');
      };
      this.init();
    };
    this.socket.onclose = (): void => {
      this.connected = false;
      if (this.reConnectionCount < 5) {
        setTimeout(() => {
          this.reConnectionCount += 1;
          this.connection();
        }, 3000);
      } else {
        if (!this.isProduction && this.socket) {
          this.socket.close();
        }
      }
    };
    this.socket.onerror = (error): void => {
      // console.log(error);
    };
  }

  public init(): void {
    this.getVersion();
    this.getTokenList();
    this.getKeyList();
  }

  public getKeyList(): void {
    const requestId = Math.random();
    this.sent(requestId, 'list_all_keys', 'token').then((response: UzCryptoServiceResponse) => {
      const list: any[] = response.result;
      list.forEach(token => {
        const certs: any[] = token.certs;
        certs.forEach(cert => {
          cert.subject = subjectParse(cert.subject);
        });
      });
      if (list.length) {
        this.activeKey = {
          token: list[0].token,
          serial: list[0].certs[0].serial,
          url: `${list[0].token}/${list[0].certs[0].serial}`,
          pinpp: list[0].certs[0].subject['1.2.860.3.16.1.2'],
        };
      }
      this.allKeyList = response;
    });
  }

  public getVersion(): void {
    const requestId = Math.random();
    this.sent(requestId, 'version', 'uzcrypto').then(result => {
      this.version = result;
    });
  }

  public getDigestHex(requestId: number, dataInBase64: string): Promise<any> {
    return this.sent(requestId, 'get_digest_hex', 'cryptoauth', [dataInBase64]);
  }

  public getTokenList(): void {
    const requestId = Math.random();
    this.sent(requestId, 'list_tokens', 'token').then((response: UzCryptoServiceResponse) => {
      this.tokenList = response;
    });
  }

  public createPkcs7(requestId: number, args: string[]): Promise<UzCryptoServiceResponse> {
    return this.sent(requestId, 'create_pkcs7', 'pkcs7', args);
  }

  public sent(requestId: number, name: string, plugin: string, args: any[] = []): Promise<any> {
    return new Promise((resolve, reject) => {
      if (requestId) {
        const params = { arguments: args, cbid: requestId, name, plugin };
        this.socket!.send(JSON.stringify(params));
        this.socket!.onmessage = (event): void => {
          const response: UzCryptoServiceResponse = JSON.parse(event.data);
          if (response.token && response.token === 'on') {
            console.log('Plug token');
            this.init();
          }
          if (response.token && response.token === 'off') {
            console.log('Unplug token');
            // this._authService.signOut(); // You might need to replace this with Vue-specific authentication logic
          }
          if (response.cbid === requestId) {
            resolve(response);
          }
        };
        this.socket!.onerror = (error): void => {
          reject(error);
        };
      }
    });
  }

  public get activeKey$(): { token: string; serial: string; url: string; pinpp: string } | null {
    return this.activeKey;
  }

  public get reConnectionCount$(): number {
    return this.reConnectionCount;
  }

  public get version$(): UzCryptoServiceResponse | null {
    return this.version;
  }

  public get connected$(): boolean {
    return this.connected;
  }

  public get tokenList$(): UzCryptoServiceResponse | null {
    return this.tokenList;
  }

  public get allKeyList$(): UzCryptoServiceResponse | null {
    return this.allKeyList;
  }

  public get response$(): UzCryptoServiceResponse | null {
    return this.response;
  }
}
